import { render, staticRenderFns } from "./main-menu.vue?vue&type=template&id=9944f40a&scoped=true"
import script from "./main-menu.vue?vue&type=script&lang=js"
export * from "./main-menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9944f40a",
  null
  
)

export default component.exports